import validateSubtitleFile from './subtitleFileValidation';

const languageFieldNames = {
  fi: 'video_text_track_file_finnish',
  en: 'video_text_track_file_english',
  sv: 'video_text_track_file_swedish'
};

const validateChapters = async (chapters) => {
  const files = Object.fromEntries(Object.entries(chapters || {}).filter(([, file]) => file != null));
  const invalid = Object.fromEntries(Object.entries(files)
    .filter(([language, file]) => !languageFieldNames[language] || !/\.vtt$/i.test(file.name) || file.size > 1024 * 1024)
    .map(([language]) => [language, 'record_validation_subtitle_invalid_format']));
  const validFiles = Object.fromEntries(Object.entries(files).filter(([language]) => !invalid[language]));

  if (Object.keys(validFiles).length) {
    const subtitleFiles = Object.fromEntries(Object.entries(validFiles)
      .map(([language, file]) => [languageFieldNames[language], file]));
    const formatErrors = await validateSubtitleFile(subtitleFiles);
    const chapterErrors = Object.fromEntries(Object.entries(formatErrors || {}).map(([field, error]) => [
      Object.keys(languageFieldNames).find(language => languageFieldNames[language] === field), error
    ]));
    return Object.keys(invalid).length || Object.keys(chapterErrors).length
      ? {...invalid, ...chapterErrors}
      : false;
  }
  return Object.keys(invalid).length ? invalid : false;
};

export default validateChapters;